module.exports = __webpack_public_path__ + "img/ic_twotone_cal@2x.f6c8ac5b.png";